import type { BotWorkerRequest } from "./protocol";
import type { BotWorkerFactory, BotWorkerHandlers, BotWorkerPort } from "./client";

class BrowserBotWorkerPort implements BotWorkerPort {
  readonly #worker: Worker;

  constructor() {
    this.#worker = new Worker(new URL("./bot.worker.ts", import.meta.url), {
      type: "module",
      name: "passo-bot",
    });
  }

  postMessage(message: BotWorkerRequest): void {
    this.#worker.postMessage(message);
  }

  setHandlers(handlers: BotWorkerHandlers): void {
    this.#worker.onmessage = (event: MessageEvent<unknown>) => handlers.message(event.data);
    this.#worker.onerror = () => handlers.error();
    this.#worker.onmessageerror = () => handlers.messageError();
  }

  terminate(): void {
    this.#worker.terminate();
  }
}

export const createBrowserBotWorker: BotWorkerFactory = () => new BrowserBotWorkerPort();
